// TODO 短信跳转小程序加v

export default [
  {
    path: '/add-wechat/index',
    name: 'addWechat',
    component: () => import(/* webpackChunkName: "addWechat" */ '@/views/add-wechat/index.vue')
  }
]
